var _rect, _rect2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardPlaidLarge = function SvgCardPlaidLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 235 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 234,
    height: 146,
    rx: 15.5,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 234,
    height: 146,
    rx: 15.5,
    stroke: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card-plaid-large_svg__a)",
    d: "M106 24h105v105H106z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.099 77.731c.954 0 1.727.774 1.727 1.728v7.314c0 .955-.773 1.729-1.727 1.729h-5.683a1.729 1.729 0 0 1-1.728-1.729V79.46c0-.954.774-1.728 1.728-1.728H46.1Zm11.424 2.938c.954 0 1.727.773 1.727 1.728v4.376c0 .955-.773 1.729-1.727 1.729h-5.684a1.728 1.728 0 0 1-1.727-1.729v-4.376c0-.955.773-1.728 1.727-1.728h5.684ZM34.675 65c.954 0 1.728.773 1.728 1.728v20.044c0 .954-.774 1.727-1.728 1.727H22.452a1.728 1.728 0 0 1-1.416-.736l-2.598-3.713a1.729 1.729 0 0 1-.313-.991V70.44c0-.354.11-.7.313-.99l2.598-3.713A1.729 1.729 0 0 1 22.452 65h12.223Zm22.848 0c.953 0 1.727.774 1.727 1.728V76.98c0 .953-.773 1.727-1.727 1.727h-5.684a1.728 1.728 0 0 1-1.727-1.727V66.728c0-.955.773-1.728 1.727-1.728h5.684Zm-11.424 0c.954 0 1.727.773 1.727 1.728v7.315c0 .954-.773 1.727-1.727 1.727h-5.683a1.728 1.728 0 0 1-1.728-1.727v-7.316c0-.954.774-1.727 1.728-1.727H46.1Z",
    fill: "#E7ECE9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "card-plaid-large_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#card-plaid-large_svg__image0_296_9955",
    transform: "scale(.00658)"
  })))));
};
export default SvgCardPlaidLarge;